import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import {
  StepIcon,
  DashBoardMenu,
  HelpIcon,
  AccountIcon,
  GaMenu,
  ChanelsMenu,
  ChanelsManualMenu,
  EcomMenu,
  AmoCrmMenuIcon,
  CallTrackingMenuIcon,
  ChatMenuIcon,
  LogoutIcon,
  ShevroneIcon,
  Handshake,
} from '../app-icon/Icons'

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    position: 'relative',
    display: 'block',
    padding: 0,
    height: 'auto',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255)',
      '& $menuLink': {
        color: '#8866ff',
      },
      '& $icon': {
        fill: 'rgb(136, 102, 255)',
      },
    },
  },
  menuLink: {
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    outline: 'none',
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre',
  },
  icon: {
    width: 24,
    fill: 'rgb(0, 0, 0)',
  },
  selectedItem: {
    backgroundColor: 'transparent !important',
    '&::after': {
      content: '" "',
      position: 'absolute',
      top: '50%',
      right: 0,
      height: 24,
      width: 4,
      backgroundColor: 'rgb(136, 102, 255)',
      pointerEvents: 'none',
      borderRadius: 2,
      marginTop: '-12px',
    },
    '& $menuLink': {
      color: 'rgb(136, 102, 255)',
    },
    '& $icon': {
      fill: 'rgb(136, 102, 255)',
    },
  },
  menuToggler: {
    padding: '0 5px',
    textAlign: 'right',
    margin: 0,
    width: '100%',
    border: 0,
    borderBottom: 'solid 0.5px rgba(0, 0, 0, 0.2)',
    height: 20,
    outline: 0,
    cursor: 'pointer',
    backgroundColor: 'transparent',
  },
  iconToggler: {
    width: 8,
    height: 8,
  },
  iconTogglerWrap: {
    display: 'inline-flex',
  },
})

class LeftNavigationDashboard extends Component {
  state = {
    isWizardFinish: window.state.user.wizard_finished_at,
    license: window.state.license,
    isNavOpen: true,
    isEcom: window.state.user.ecom_view,
    isGDSAllow: window.state.user.is_gds_allow,
  }

  setNavOpen = () => {
    this.setState(
      ({ isNavOpen }) => {
        return {
          isNavOpen: !isNavOpen,
        }
      },
      () =>
        localStorage.setItem('isNavOpen', JSON.stringify(this.state.isNavOpen))
    )
  }

  componentDidMount() {
    const data = localStorage.getItem('isNavOpen')
    this.setState(({ isNavOpen }) => {
      return {
        isNavOpen: data != null ? JSON.parse(data) : isNavOpen,
      }
    })
  }

  render() {
    const { classes, className } = this.props
    const { isEcom } = this.state

    return (
      <div style={{ marginRight: 42 }}>
        <div
          className={className}
          style={{
            maxWidth: this.state.isNavOpen ? 140 : 55,
            transition: '0.4s linear',
            willChange: 'transform',
          }}
        >
          <Paper className={classes.root}>
            <button className={classes.menuToggler} onClick={this.setNavOpen}>
              <span
                className={classes.iconTogglerWrap}
                style={{
                  transform: this.state.isNavOpen
                    ? 'rotate(-180deg)'
                    : 'rotate(0)',
                  transition: '0.4s linear',
                  willChange: 'transform',
                }}
              >
                <ShevroneIcon
                  className={classes.iconToggler}
                  stroke="#00000033"
                />
              </span>
            </button>
            <MenuList className={classes.menuList}>
              {!this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/wizard'}
                  disableGutters
                  classes={{
                    root: classes.menuItem,
                    selected: classes.selectedItem,
                  }}
                >
                  <a
                    href="/wizard"
                    className={classes.menuLink}
                    style={{ padding: '16px' }}
                  >
                    <ListItemIcon>
                      <StepIcon className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Начальная \nнастройка`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={
                    '/' + location.pathname.split('/')[1] === '/dashboard'
                  }
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                  style={{ borderBottom: 'solid 0.5px rgba(0, 0, 0, 0.2)' }}
                >
                  <a
                    href="/dashboard"
                    className={classes.menuLink}
                    style={{ padding: '16px' }}
                  >
                    <ListItemIcon>
                      <DashBoardMenu className={classes.icon} />
                    </ListItemIcon>
                    <span>ДАШБОРД</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/ga'}
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <a href="/ga" className={classes.menuLink}>
                    <ListItemIcon>
                      <GaMenu className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Google \nAnalytics`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={
                    '/' + location.pathname.split('/')[1] === '/sources'
                  }
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                >
                  <a href="/sources" className={classes.menuLink}>
                    <ListItemIcon>
                      <ChanelsMenu className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Рекламные \nканалы`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={
                    '/' + location.pathname.split('/')[1] === '/statistics'
                  }
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                >
                  <a href="/statistics" className={classes.menuLink}>
                    <ListItemIcon>
                      <ChanelsManualMenu className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Ручной ввод \nрасходов`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && isEcom && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/ecom'}
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                >
                  <a href="/ecom" className={classes.menuLink}>
                    <ListItemIcon>
                      <EcomMenu
                        width={24}
                        height={24}
                        className={classes.icon}
                      />
                    </ListItemIcon>
                    <span>{`Электронная \nторговля`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/crm'}
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                >
                  <a href="/crm" className={classes.menuLink}>
                    <ListItemIcon>
                      <AmoCrmMenuIcon className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Данные \nиз CRM`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={
                    '/' + location.pathname.split('/')[1] === '/calltracking'
                  }
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                >
                  <a href="/calltracking" className={classes.menuLink}>
                    <ListItemIcon>
                      <CallTrackingMenuIcon className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Данные из \nколлтрекинга`}</span>
                  </a>
                </MenuItem>
              )}

              {this.state.isWizardFinish && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/chat'}
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                  style={{
                    marginBottom: 8,
                  }}
                >
                  <a href="/chat" className={classes.menuLink}>
                    <ListItemIcon>
                      <ChatMenuIcon className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Данные из \nчата`}</span>
                  </a>
                </MenuItem>
              )}
              {this.state.isGDSAllow && (
                <MenuItem
                  className={classes.menuItem}
                  selected={'/' + location.pathname.split('/')[1] === '/ga'}
                  disableGutters
                  classes={{ selected: classes.selectedItem }}
                  style={{
                    marginTop: 8,
                  }}
                >
                  <a href="/gds" className={classes.menuLink}>
                    <ListItemIcon>
                      <GaMenu className={classes.icon} />
                    </ListItemIcon>
                    <span>{`Отчеты GDS`}</span>
                  </a>
                </MenuItem>
              )}

              <MenuItem
                className={classes.menuItem}
                selected={'/' + location.pathname.split('/')[1] === '/help'}
                disableGutters
                classes={{ selected: classes.selectedItem }}
                style={{
                  borderTop: 'solid 0.5px rgba(0, 0, 0, 0.2)',
                  paddingTop: 8,
                }}
              >
                <a href="/help" className={classes.menuLink}>
                  <ListItemIcon>
                    <HelpIcon className={classes.icon} />
                  </ListItemIcon>
                  <span>ПОМОЩЬ</span>
                </a>
              </MenuItem>

              <MenuItem
                className={classes.menuItem}
                selected={'/' + location.pathname.split('/')[1] === '/profile'}
                disableGutters
                classes={{ selected: classes.selectedItem }}
              >
                <a href="/profile" className={classes.menuLink}>
                  <ListItemIcon>
                    <AccountIcon className={classes.icon} />
                  </ListItemIcon>
                  <span>АККАУНТ</span>
                </a>
              </MenuItem>

              <MenuItem
                className={classes.menuItem}
                selected={'/' + location.pathname.split('/')[1] === '/logout'}
                disableGutters
                classes={{ selected: classes.selectedItem }}
                style={{
                  marginBottom: 8,
                }}
              >
                <a href="/logout" className={classes.menuLink}>
                  <ListItemIcon>
                    <LogoutIcon
                      width={24}
                      height={24}
                      className={classes.icon}
                    />
                  </ListItemIcon>
                  <span>ВЫХОД</span>
                </a>
              </MenuItem>
            </MenuList>
          </Paper>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(LeftNavigationDashboard)
